import React from 'react';

/* SVG version of the Slack mark · keeps the brand color (we can't pull
 * lucide-react's stylized icon, and an inline SVG avoids shipping the
 * official wordmark image around the bundle). */
function SlackIcon({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#E01E5A" d="M5.04 15.16a2.13 2.13 0 1 1-2.13-2.13h2.13zm1.07 0a2.13 2.13 0 1 1 4.26 0v5.32a2.13 2.13 0 1 1-4.26 0z"/>
      <path fill="#36C5F0" d="M8.24 5a2.13 2.13 0 1 1 2.13 2.13H8.24zm0 1.07a2.13 2.13 0 1 1 0 4.26H2.93a2.13 2.13 0 1 1 0-4.26z"/>
      <path fill="#2EB67D" d="M19.07 8.16a2.13 2.13 0 1 1 2.13 2.13h-2.13zm-1.07 0a2.13 2.13 0 1 1-4.26 0V2.84a2.13 2.13 0 1 1 4.26 0z"/>
      <path fill="#ECB22E" d="M15.87 19.32a2.13 2.13 0 1 1-2.13-2.13h2.13zm0-1.07a2.13 2.13 0 1 1 0-4.26h5.32a2.13 2.13 0 1 1 0 4.26z"/>
    </svg>
  );
}

/**
 * Tiny "open a DM in Slack" button. We use the `slack://` deep link
 * (with a web fallback) because we don't want OAuth and don't need to
 * post anything · clicking just opens a fresh DM with the person.
 *
 * VITE_SLACK_WORKSPACE_ID has to be set at build time for the link to
 * resolve. If either id is missing, the component renders nothing so
 * the layout doesn't reserve dead space.
 */
const WORKSPACE = import.meta.env.VITE_SLACK_WORKSPACE_ID || '';

export default function SlackLink({ slackUserId, size = 14, className = '', title = 'Slack' }) {
  if (!WORKSPACE || !slackUserId) return null;
  // The deep link opens the desktop app; the https URL is the fallback
  // for browsers without the protocol handler · we put both on the
  // anchor (target=_blank handles the web case naturally).
  const webUrl = `https://app.slack.com/client/${WORKSPACE}/${slackUserId}`;
  const onClick = (e) => {
    // Try the desktop app first; if it doesn't take, the new tab opens.
    const deepLink = `slack://user?team=${WORKSPACE}&id=${slackUserId}`;
    window.location.href = deepLink;
    // Let the browser still navigate to the https fallback in the
    // background tab; if the OS handler grabbed the slack:// URL the
    // tab closes itself, otherwise the user lands on app.slack.com.
    void e;
  };
  return (
    <a
      href={webUrl}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
      title={title}
      aria-label={title}
      className={`inline-flex items-center justify-center rounded transition hover:opacity-80 ${className}`}
    >
      <SlackIcon size={size} />
    </a>
  );
}
